import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";
import CountryBlock from "@/components/CountryBlock";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import IndexFr from "./pages/IndexFr";
import IndexVi from "./pages/IndexVi";
import IndexTw from "./pages/IndexTw";
import IndexKr from "./pages/IndexKr";
import IndexJp from "./pages/IndexJp";
import IndexCn from "./pages/IndexCn";
import OnlineWorkspace from "./pages/OnlineWorkspace";
import ProductivityTool from "./pages/ProductivityTool";
import StudyStreamPage from "./pages/StudyStream";
import StudyStreamRedirect from "./pages/StudyStreamRedirect";
import WhyStudyingOnCameraHelps from "./pages/study-stream/WhyStudyingOnCameraHelps";
import GongbangToGlobal from "./pages/study-stream/GongbangToGlobal";
import TechToolkitSuccess from "./pages/study-stream/TechToolkitSuccess";
import ProductivityHacks from "./pages/study-stream/ProductivityHacks";
import StudyStreamVsStudyGroup from "./pages/study-stream/StudyStreamVsStudyGroup";
import StudyingAloneTogether from "./pages/study-stream/StudyingAloneTogether";
import Pomodoro20 from "./pages/study-stream/Pomodoro20";
import PomodoroTechnique from "./pages/PomodoroTechnique";
import Pomodoro101 from "./pages/pomodoro/Pomodoro101";
import ScienceOfFocus from "./pages/pomodoro/ScienceOfFocus";
import DoesItWork from "./pages/pomodoro/DoesItWork";
import PomodoroVsProcrastination from "./pages/pomodoro/PomodoroVsProcrastination";
import StudyHabits from "./pages/pomodoro/StudyHabits";
import AvoidBurnout from "./pages/pomodoro/AvoidBurnout";
import BestTools from "./pages/pomodoro/BestTools";
import StudyStreams from "./pages/pomodoro/StudyStreams";
import CustomizePomodoro from "./pages/pomodoro/CustomizePomodoro";
import WhyBreaksMatter from "./pages/pomodoro/WhyBreaksMatter";
import ExamPrep from "./pages/pomodoro/ExamPrep";
import ActiveLearning from "./pages/pomodoro/ActiveLearning";
import PomodoroADHD from "./pages/pomodoro/PomodoroADHD";
import Reminders from "./pages/Reminders";
import StudyTimer from "./pages/StudyTimer";
import TaskManagement from "./pages/TaskManagement";
import TasksRedirect from "./pages/TasksRedirect";
import Quizzes from "./pages/Quizzes";
import FlashCards from "./pages/FlashCards";
import StudyRoom from "./pages/StudyRoom";
// Study Room university pages - Toronto
import UofTStGeorge from "./pages/study-room/UofTStGeorge";
import UofTMississauga from "./pages/study-room/UofTMississauga";
import UofTScarborough from "./pages/study-room/UofTScarborough";
import YorkUniversity from "./pages/study-room/YorkUniversity";
import TorontoMetropolitanUniversity from "./pages/study-room/TorontoMetropolitanUniversity";
import OCADUniversity from "./pages/study-room/OCADUniversity";
import GuelphHumber from "./pages/study-room/GuelphHumber";
import SenecaCollege from "./pages/study-room/SenecaCollege";
import HumberCollege from "./pages/study-room/HumberCollege";
// Study Room university pages - Canada
import McGillUniversity from "./pages/study-room/McGillUniversity";
import UBCVancouver from "./pages/study-room/UBCVancouver";
import UniversityOfAlberta from "./pages/study-room/UniversityOfAlberta";
import UniversityOfCalgary from "./pages/study-room/UniversityOfCalgary";
import UniversityOfOttawa from "./pages/study-room/UniversityOfOttawa";
import McMasterUniversity from "./pages/study-room/McMasterUniversity";
import UniversityOfWaterloo from "./pages/study-room/UniversityOfWaterloo";
import WesternUniversity from "./pages/study-room/WesternUniversity";
import QueensUniversity from "./pages/study-room/QueensUniversity";
import UniversityOfManitoba from "./pages/study-room/UniversityOfManitoba";
import UniversityOfSaskatchewan from "./pages/study-room/UniversityOfSaskatchewan";
import UniversiteLaval from "./pages/study-room/UniversiteLaval";
import UniversiteDeMontreal from "./pages/study-room/UniversiteDeMontreal";
import DalhousieUniversity from "./pages/study-room/DalhousieUniversity";
import SimonFraserUniversity from "./pages/study-room/SimonFraserUniversity";
import ConcordiaUniversity from "./pages/study-room/ConcordiaUniversity";
import UniversityOfVictoria from "./pages/study-room/UniversityOfVictoria";
import MemorialUniversity from "./pages/study-room/MemorialUniversity";
import CarletonUniversity from "./pages/study-room/CarletonUniversity";
import UniversityOfNewBrunswick from "./pages/study-room/UniversityOfNewBrunswick";
// Study Room university pages - USA
import UniversityOfCentralFlorida from "./pages/study-room/UniversityOfCentralFlorida";
import TexasAMUniversity from "./pages/study-room/TexasAMUniversity";
import OhioStateUniversity from "./pages/study-room/OhioStateUniversity";
import FloridaInternationalUniversity from "./pages/study-room/FloridaInternationalUniversity";
import UniversityOfFlorida from "./pages/study-room/UniversityOfFlorida";
import NewYorkUniversity from "./pages/study-room/NewYorkUniversity";
import UniversityOfTexasAustin from "./pages/study-room/UniversityOfTexasAustin";
import ArizonaStateUniversity from "./pages/study-room/ArizonaStateUniversity";
import UniversityOfMinnesota from "./pages/study-room/UniversityOfMinnesota";
import MichiganStateUniversity from "./pages/study-room/MichiganStateUniversity";
import RutgersUniversity from "./pages/study-room/RutgersUniversity";
import UniversityOfIllinois from "./pages/study-room/UniversityOfIllinois";
import UniversityOfWashington from "./pages/study-room/UniversityOfWashington";
import PennStateUniversity from "./pages/study-room/PennStateUniversity";
import PurdueUniversity from "./pages/study-room/PurdueUniversity";
import UniversityOfSouthernCalifornia from "./pages/study-room/UniversityOfSouthernCalifornia";
import IndianaUniversity from "./pages/study-room/IndianaUniversity";
import UCLA from "./pages/study-room/UCLA";
import UniversityOfMichigan from "./pages/study-room/UniversityOfMichigan";
import UCBerkeley from "./pages/study-room/UCBerkeley";
import CSWvsQuizlet from "./pages/quizzes/CSWvsQuizlet";
import CSWvsTestPrepReview from "./pages/quizzes/CSWvsTestPrepReview";
import CSWvsStudioity from "./pages/quizzes/CSWvsStudioity";
import CSWvsThea from "./pages/quizzes/CSWvsThea";
import CSWvsQuizMe from "./pages/quizzes/CSWvsQuizMe";
import CSWvsFlexiQuiz from "./pages/quizzes/CSWvsFlexiQuiz";
import CSWvsQuizMaker from "./pages/quizzes/CSWvsQuizMaker";
import CSWvsRevisely from "./pages/quizzes/CSWvsRevisely";
import CSWvsQuizWhiz from "./pages/quizzes/CSWvsQuizWhiz";
import CSWvsTestudy from "./pages/quizzes/CSWvsTestudy";
import CSWvsCanva from "./pages/quizzes/CSWvsCanva";
import CSWvsGoogleForms from "./pages/quizzes/CSWvsGoogleForms";
import CSWvsClassMarker from "./pages/quizzes/CSWvsClassMarker";
import CSWvsWooclap from "./pages/quizzes/CSWvsWooclap";
import CSWvsGenially from "./pages/quizzes/CSWvsGenially";
// Quiz topic pages
import FunQuizzesToTake from "./pages/quizzes/FunQuizzesToTake";
import VideoGameQuizzes from "./pages/quizzes/VideoGameQuizzes";
import ArtQuizzes from "./pages/quizzes/ArtQuizzes";
import MusicQuizzes from "./pages/quizzes/MusicQuizzes";
import FoodQuizzes from "./pages/quizzes/FoodQuizzes";
import HistoryQuizzes from "./pages/quizzes/HistoryQuizzes";
import ScienceQuizzes from "./pages/quizzes/ScienceQuizzes";
import PopCultureQuizzes from "./pages/quizzes/PopCultureQuizzes";
import TriviaQuizzes from "./pages/quizzes/TriviaQuizzes";
import PersonalityQuizzes from "./pages/quizzes/PersonalityQuizzes";
// Flashcard comparison pages
import CSWvsNoteGPT from "./pages/flashcards/CSWvsNoteGPT";
import CSWvsAnki from "./pages/flashcards/CSWvsAnki";
import CSWvsCram from "./pages/flashcards/CSWvsCram";
import CSWvsBrainscape from "./pages/flashcards/CSWvsBrainscape";
import CSWvsMemrise from "./pages/flashcards/CSWvsMemrise";
import CSWvsFlashcardMachine from "./pages/flashcards/CSWvsFlashcardMachine";
import CSWvsStudyBlue from "./pages/flashcards/CSWvsStudyBlue";
import CSWvsStudyStack from "./pages/flashcards/CSWvsStudyStack";
import CSWvsAnkiApp from "./pages/flashcards/CSWvsAnkiApp";
import CSWvsKnowt from "./pages/flashcards/CSWvsKnowt";
import CSWvsProProfs from "./pages/flashcards/CSWvsProProfs";
import CSWvsRemNote from "./pages/flashcards/CSWvsRemNote";
import CSWvsKahoot from "./pages/flashcards/CSWvsKahoot";
import CSWvsMemozora from "./pages/flashcards/CSWvsMemozora";
import CSWvsiDoRecall from "./pages/flashcards/CSWvsiDoRecall";
import CSWvsStudyKit from "./pages/flashcards/CSWvsStudyKit";
// Workspace comparison pages
import CSWvsNotion from "./pages/workspace/CSWvsNotion";
import CSWvsMonday from "./pages/workspace/CSWvsMonday";
import CSWvsClickUp from "./pages/workspace/CSWvsClickUp";
import CSWvsAsana from "./pages/workspace/CSWvsAsana";
import CSWvsTrello from "./pages/workspace/CSWvsTrello";
import CSWvsSlack from "./pages/workspace/CSWvsSlack";
import CSWvsMiro from "./pages/workspace/CSWvsMiro";
import CSWvsBasecamp from "./pages/workspace/CSWvsBasecamp";
import CSWvsCoda from "./pages/workspace/CSWvsCoda";
import CSWvsAirtable from "./pages/workspace/CSWvsAirtable";
// Timer comparison pages
import CSWvsPomodor from "./pages/timer/CSWvsPomodor";
import CSWvsOtto from "./pages/timer/CSWvsOtto";
import CSWvsForest from "./pages/timer/CSWvsForest";
import CSWvsSessionTimer from "./pages/timer/CSWvsSession";
import CSWvsFlowTimer from "./pages/timer/CSWvsFlow";
import CSWvsTogglTrack from "./pages/timer/CSWvsTogglTrack";
import CSWvsFocusBooster from "./pages/timer/CSWvsFocusBooster";
import CSWvsBeFocused from "./pages/timer/CSWvsBeFocused";
import CSWvsPomoDone from "./pages/timer/CSWvsPomoDone";
import CSWvsPomofocus from "./pages/timer/CSWvsPomofocus";
import CSWvsFocusKeeper from "./pages/timer/CSWvsFocusKeeper";
import CSWvsMinimalist from "./pages/timer/CSWvsMinimalist";
import CSWvsFlocus from "./pages/timer/CSWvsFlocus";
import CSWvsTaskade from "./pages/timer/CSWvsTaskade";
import CSWvsFocusAtWill from "./pages/timer/CSWvsFocusAtWill";
import CSWvsColdTurkey from "./pages/timer/CSWvsColdTurkey";
import CSWvsBrainFm from "./pages/timer/CSWvsBrainFm";
import CSWvsFreedom from "./pages/timer/CSWvsFreedom";
import StudyVerse from "./pages/StudyVerse";
import StudyVerseRedirect from "./pages/StudyVerseRedirect";
import StudyWithSKZ from "./pages/StudyWithSKZ";
import StudyWithItzy from "./pages/StudyWithItzy";
import StudyWithBlackpink from "./pages/StudyWithBlackpink";
import StudyWithAespa from "./pages/StudyWithAespa";
import StudyWithTwice from "./pages/StudyWithTwice";
import StudyWithAteez from "./pages/StudyWithAteez";
import StudyWithBTS from "./pages/StudyWithBTS";
import StudyWithEnhypen from "./pages/StudyWithEnhypen";
import StudyWithNCT from "./pages/StudyWithNCT";
import StudyWithTXT from "./pages/StudyWithTXT";
import StudyWithSeventeen from "./pages/StudyWithSeventeen";
import StudyWithEXO from "./pages/StudyWithEXO";
import StudyWithMonstaX from "./pages/StudyWithMonstaX";
import StudyWithTheBoyz from "./pages/StudyWithTheBoyz";
import StudyWithTreasure from "./pages/StudyWithTreasure";
import StudyWithGOT7 from "./pages/StudyWithGOT7";
import StudyWithSF9 from "./pages/StudyWithSF9";
import StudyWithLoona from "./pages/StudyWithLoona";
import StudyWithRedVelvet from "./pages/StudyWithRedVelvet";
import StudyWithMamamoo from "./pages/StudyWithMamamoo";
import StudyWithKpop from "./pages/StudyWithKpop";
import StudyWithMe from "./pages/StudyWithMe";
import StudyWithFriends from "./pages/StudyWithFriends";
import StudyWithStrangers from "./pages/StudyWithStrangers";
import GroupStudy from "./pages/GroupStudy";
import ZoomStudyRoom from "./pages/ZoomStudyRoom";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import UserRegistrationPolicy from "./pages/UserRegistrationPolicy";
import ContentMonitoringPolicy from "./pages/ContentMonitoringPolicy";
import ReportPolicy from "./pages/ReportPolicy";
import Blog from "./pages/Blog";
import HowTurningOnMyCameraBoostedMyProductivity from "./pages/blog/HowTurningOnMyCameraBoostedMyProductivity";
import HowToStopProcrastination from "./pages/blog/HowToStopProcrastination";
import Top10DigitalToolsForAcademicSuccess from "./pages/blog/Top10DigitalToolsForAcademicSuccess";
import PreparingForMajorTest from "./pages/blog/PreparingForMajorTest";
import BenefitsOfOnlineLearningCommunity from "./pages/blog/BenefitsOfOnlineLearningCommunity";
import ScienceBehindStudyWithMe from "./pages/blog/ScienceBehindStudyWithMe";
import AppsBoostProductivityCollege from "./pages/blog/AppsBoostProductivityCollege";
import AppsBoostOrganizationCollege from "./pages/blog/AppsBoostOrganizationCollege";
import AppsBoostSelfGrowthCollege from "./pages/blog/AppsBoostSelfGrowthCollege";
import PaperVsDigitalPlanning from "./pages/blog/PaperVsDigitalPlanning";
import TaskManagementToolsReview from "./pages/blog/TaskManagementToolsReview";
// Online Study platform pages
import OnlineStudy from "./pages/OnlineStudy";
import KhanAcademy from "./pages/online-study/KhanAcademy";
import Quizlet from "./pages/online-study/Quizlet";
import WolframAlpha from "./pages/online-study/WolframAlpha";
import SparkNotes from "./pages/online-study/SparkNotes";
import Magoosh from "./pages/online-study/Magoosh";
import Kaplan from "./pages/online-study/Kaplan";
import PrincetonReview from "./pages/online-study/PrincetonReview";
import Fiveable from "./pages/online-study/Fiveable";
import Chegg from "./pages/online-study/Chegg";
import CourseHero from "./pages/online-study/CourseHero";
import Brainly from "./pages/online-study/Brainly";
import Focusmate from "./pages/online-study/Focusmate";
import StudyStreamPlatform from "./pages/online-study/StudyStreamPlatform";
import StudyTogether from "./pages/online-study/StudyTogether";
import Coursera from "./pages/online-study/Coursera";
import Edx from "./pages/online-study/Edx";
import Udemy from "./pages/online-study/Udemy";
import YPTYeolPumTa from "./pages/online-study/YPTYeolPumTa";
import YPTYeolPumTaKr from "./pages/online-study/YPTYeolPumTaKr";
import Flown from "./pages/workspace/Flown";
import GatherTown from "./pages/workspace/GatherTown";
import Caveday from "./pages/workspace/Caveday";
import Cofocus from "./pages/workspace/Cofocus";
import BlockedPreview from "./pages/BlockedPreview";
import StudyVerseHistory from "./pages/StudyVerseHistory";
import GrooveHistory from "./pages/GrooveHistory";
import Groove from "./pages/Groove";
import Edmodo from "./pages/Edmodo";
import EdmodoHistory from "./pages/EdmodoHistory";
import OpenStudy from "./pages/OpenStudy";
import OpenStudyHistory from "./pages/OpenStudyHistory";
import Wunderlist from "./pages/Wunderlist";
import WunderlistHistory from "./pages/WunderlistHistory";
import AltspaceVR from "./pages/AltspaceVR";
import AltspaceVRHistory from "./pages/AltspaceVRHistory";
import GoogleWave from "./pages/GoogleWave";
import GoogleWaveHistory from "./pages/GoogleWaveHistory";
import HipChat from "./pages/HipChat";
import HipChatHistory from "./pages/HipChatHistory";
import Stride from "./pages/Stride";
import StrideHistory from "./pages/StrideHistory";
import SunriseCalendar from "./pages/SunriseCalendar";
import SunriseCalendarHistory from "./pages/SunriseCalendarHistory";
import Mailbox from "./pages/Mailbox";
import MailboxHistory from "./pages/MailboxHistory";
import YahooGroups from "./pages/YahooGroups";
import YahooGroupsHistory from "./pages/YahooGroupsHistory";
import GoogleSpaces from "./pages/GoogleSpaces";
import GoogleSpacesHistory from "./pages/GoogleSpacesHistory";
import Quill from "./pages/Quill";
import QuillHistory from "./pages/QuillHistory";
import GoogleHangouts from "./pages/GoogleHangouts";
import GoogleHangoutsHistory from "./pages/GoogleHangoutsHistory";
import Chalkup from "./pages/Chalkup";
import ChalkupHistory from "./pages/ChalkupHistory";
import TodaysMeet from "./pages/TodaysMeet";
import TodaysMeetHistory from "./pages/TodaysMeetHistory";
import Wikispaces from "./pages/Wikispaces";
import WikispacesHistory from "./pages/WikispacesHistory";
import Astrid from "./pages/Astrid";
import AstridHistory from "./pages/AstridHistory";
import Producteev from "./pages/Producteev";
import ProducteevHistory from "./pages/ProducteevHistory";
import Sandglaz from "./pages/Sandglaz";
import SandglazHistory from "./pages/SandglazHistory";
import Fetchnotes from "./pages/Fetchnotes";
import FetchnotesHistory from "./pages/FetchnotesHistory";
import IQTell from "./pages/IQTell";
import IQTellHistory from "./pages/IQTellHistory";
import Height from "./pages/Height";
import HeightHistory from "./pages/HeightHistory";
import GoogleTables from "./pages/GoogleTables";
import GoogleTablesHistory from "./pages/GoogleTablesHistory";
import Alternatives from "./pages/Alternatives";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <CountryBlock>
        <ScrollToTop />
        <Toaster />
        <Sonner />
        <Routes>
          <Route path="/" element={<Index />} />
        <Route path="/fr/" element={<IndexFr />} />
        <Route path="/vn/" element={<IndexVi />} />
        <Route path="/tw/" element={<IndexTw />} />
        <Route path="/kr/" element={<IndexKr />} />
        <Route path="/jp/" element={<IndexJp />} />
        <Route path="/cn/" element={<IndexCn />} />
        <Route path="/kr/online-study/ypt-yeolpumta/" element={<YPTYeolPumTaKr />} />
        <Route path="/online-workspace/" element={<OnlineWorkspace />} />
        <Route path="/online-workspace/csw-vs-notion/" element={<CSWvsNotion />} />
        <Route path="/online-workspace/csw-vs-monday/" element={<CSWvsMonday />} />
        <Route path="/online-workspace/csw-vs-clickup/" element={<CSWvsClickUp />} />
        <Route path="/online-workspace/csw-vs-asana/" element={<CSWvsAsana />} />
        <Route path="/online-workspace/csw-vs-trello/" element={<CSWvsTrello />} />
        <Route path="/online-workspace/csw-vs-slack/" element={<CSWvsSlack />} />
        <Route path="/online-workspace/csw-vs-miro/" element={<CSWvsMiro />} />
        <Route path="/online-workspace/csw-vs-basecamp/" element={<CSWvsBasecamp />} />
        <Route path="/online-workspace/csw-vs-coda/" element={<CSWvsCoda />} />
        <Route path="/online-workspace/csw-vs-airtable/" element={<CSWvsAirtable />} />
        <Route path="/productivity-tool/" element={<ProductivityTool />} />
        <Route path="/study-stream/" element={<StudyStreamPage />} />
        <Route path="/study-stream/why-studying-on-camera-helps/" element={<WhyStudyingOnCameraHelps />} />
        <Route path="/study-stream/gongbang-to-global/" element={<GongbangToGlobal />} />
        <Route path="/study-stream/tech-toolkit-for-success/" element={<TechToolkitSuccess />} />
        <Route path="/study-stream/productivity-hacks/" element={<ProductivityHacks />} />
        <Route path="/study-stream/study-stream-vs-study-group/" element={<StudyStreamVsStudyGroup />} />
        <Route path="/study-stream/studying-alone-together/" element={<StudyingAloneTogether />} />
        <Route path="/study-stream/pomodoro-20/" element={<Pomodoro20 />} />
        <Route path="/pomodoro-technique/" element={<PomodoroTechnique />} />
        <Route path="/pomodoro-technique/pomodoro-101/" element={<Pomodoro101 />} />
        <Route path="/pomodoro-technique/science-of-focus/" element={<ScienceOfFocus />} />
        <Route path="/pomodoro-technique/does-it-work/" element={<DoesItWork />} />
        <Route path="/pomodoro-technique/pomodoro-vs-procrastination/" element={<PomodoroVsProcrastination />} />
        <Route path="/pomodoro-technique/study-habits/" element={<StudyHabits />} />
        <Route path="/pomodoro-technique/avoid-burnout/" element={<AvoidBurnout />} />
        <Route path="/pomodoro-technique/best-tools/" element={<BestTools />} />
        <Route path="/pomodoro-technique/study-streams/" element={<StudyStreams />} />
        <Route path="/pomodoro-technique/customize/" element={<CustomizePomodoro />} />
        <Route path="/pomodoro-technique/why-breaks-matter/" element={<WhyBreaksMatter />} />
        <Route path="/pomodoro-technique/exam-prep/" element={<ExamPrep />} />
        <Route path="/pomodoro-technique/active-learning/" element={<ActiveLearning />} />
        <Route path="/pomodoro-technique/adhd/" element={<PomodoroADHD />} />
        <Route path="/studystream/" element={<StudyStreamRedirect />} />
        <Route path="/studystream" element={<StudyStreamRedirect />} />
        <Route path="/reminders/" element={<Reminders />} />
        <Route path="/study-timer/" element={<StudyTimer />} />
        <Route path="/study-timer/csw-vs-pomodor/" element={<CSWvsPomodor />} />
        <Route path="/study-timer/csw-vs-otto/" element={<CSWvsOtto />} />
        <Route path="/study-timer/csw-vs-forest/" element={<CSWvsForest />} />
        <Route path="/study-timer/csw-vs-session/" element={<CSWvsSessionTimer />} />
        <Route path="/study-timer/csw-vs-flow/" element={<CSWvsFlowTimer />} />
        <Route path="/study-timer/csw-vs-toggl-track/" element={<CSWvsTogglTrack />} />
        <Route path="/study-timer/csw-vs-focus-booster/" element={<CSWvsFocusBooster />} />
        <Route path="/study-timer/csw-vs-be-focused/" element={<CSWvsBeFocused />} />
        <Route path="/study-timer/csw-vs-pomodone/" element={<CSWvsPomoDone />} />
        <Route path="/study-timer/csw-vs-pomofocus/" element={<CSWvsPomofocus />} />
        <Route path="/study-timer/csw-vs-focus-keeper/" element={<CSWvsFocusKeeper />} />
        <Route path="/study-timer/csw-vs-minimalist/" element={<CSWvsMinimalist />} />
        <Route path="/study-timer/csw-vs-flocus/" element={<CSWvsFlocus />} />
        <Route path="/study-timer/csw-vs-taskade/" element={<CSWvsTaskade />} />
        <Route path="/study-timer/csw-vs-focus-at-will/" element={<CSWvsFocusAtWill />} />
        <Route path="/study-timer/csw-vs-cold-turkey/" element={<CSWvsColdTurkey />} />
        <Route path="/study-timer/csw-vs-brain-fm/" element={<CSWvsBrainFm />} />
        <Route path="/study-timer/csw-vs-freedom/" element={<CSWvsFreedom />} />
        <Route path="/task-management/" element={<TaskManagement />} />
        <Route path="/tasks/" element={<TasksRedirect />} />
        <Route path="/tasks" element={<TasksRedirect />} />
        <Route path="/quizzes/" element={<Quizzes />} />
        <Route path="/quizzes/csw-vs-quizlet/" element={<CSWvsQuizlet />} />
        <Route path="/quizzes/csw-vs-test-prep-review/" element={<CSWvsTestPrepReview />} />
        <Route path="/quizzes/csw-vs-studiosity/" element={<CSWvsStudioity />} />
        <Route path="/quizzes/csw-vs-thea/" element={<CSWvsThea />} />
        <Route path="/quizzes/csw-vs-quiz-me/" element={<CSWvsQuizMe />} />
        <Route path="/quizzes/csw-vs-flexiquiz/" element={<CSWvsFlexiQuiz />} />
        <Route path="/quizzes/csw-vs-quiz-maker/" element={<CSWvsQuizMaker />} />
        <Route path="/quizzes/csw-vs-revisely/" element={<CSWvsRevisely />} />
        <Route path="/quizzes/csw-vs-quizwhiz/" element={<CSWvsQuizWhiz />} />
        <Route path="/quizzes/csw-vs-testudy/" element={<CSWvsTestudy />} />
        <Route path="/quizzes/csw-vs-canva/" element={<CSWvsCanva />} />
        <Route path="/quizzes/csw-vs-google-forms/" element={<CSWvsGoogleForms />} />
        <Route path="/quizzes/csw-vs-classmarker/" element={<CSWvsClassMarker />} />
        <Route path="/quizzes/csw-vs-wooclap/" element={<CSWvsWooclap />} />
        <Route path="/quizzes/csw-vs-genially/" element={<CSWvsGenially />} />
        <Route path="/quizzes/fun-quizzes-to-take/" element={<FunQuizzesToTake />} />
        <Route path="/quizzes/video-game-quizzes/" element={<VideoGameQuizzes />} />
        <Route path="/quizzes/art-quizzes/" element={<ArtQuizzes />} />
        <Route path="/quizzes/music-quizzes/" element={<MusicQuizzes />} />
        <Route path="/quizzes/food-quizzes/" element={<FoodQuizzes />} />
        <Route path="/quizzes/history-quizzes/" element={<HistoryQuizzes />} />
        <Route path="/quizzes/science-quizzes/" element={<ScienceQuizzes />} />
        <Route path="/quizzes/pop-culture-quizzes/" element={<PopCultureQuizzes />} />
        <Route path="/quizzes/trivia-quizzes/" element={<TriviaQuizzes />} />
        <Route path="/quizzes/personality-quizzes/" element={<PersonalityQuizzes />} />
        <Route path="/flash-cards/" element={<FlashCards />} />
        <Route path="/flash-cards/csw-vs-notegpt/" element={<CSWvsNoteGPT />} />
        <Route path="/flash-cards/csw-vs-anki/" element={<CSWvsAnki />} />
        <Route path="/flash-cards/csw-vs-cram/" element={<CSWvsCram />} />
        <Route path="/flash-cards/csw-vs-brainscape/" element={<CSWvsBrainscape />} />
        <Route path="/flash-cards/csw-vs-memrise/" element={<CSWvsMemrise />} />
        <Route path="/flash-cards/csw-vs-flashcard-machine/" element={<CSWvsFlashcardMachine />} />
        <Route path="/flash-cards/csw-vs-studyblue/" element={<CSWvsStudyBlue />} />
        <Route path="/flash-cards/csw-vs-studystack/" element={<CSWvsStudyStack />} />
        <Route path="/flash-cards/csw-vs-ankiapp/" element={<CSWvsAnkiApp />} />
        <Route path="/flash-cards/csw-vs-knowt/" element={<CSWvsKnowt />} />
        <Route path="/flash-cards/csw-vs-proprofs/" element={<CSWvsProProfs />} />
        <Route path="/flash-cards/csw-vs-remnote/" element={<CSWvsRemNote />} />
        <Route path="/flash-cards/csw-vs-kahoot/" element={<CSWvsKahoot />} />
        <Route path="/flash-cards/csw-vs-memozora/" element={<CSWvsMemozora />} />
        <Route path="/flash-cards/csw-vs-idorecall/" element={<CSWvsiDoRecall />} />
        <Route path="/flash-cards/csw-vs-studykit/" element={<CSWvsStudyKit />} />
        <Route path="/study-room/" element={<StudyRoom />} />
        {/* Toronto Area Universities */}
        <Route path="/study-room/university-of-toronto-st-george/" element={<UofTStGeorge />} />
        <Route path="/study-room/university-of-toronto-mississauga/" element={<UofTMississauga />} />
        <Route path="/study-room/university-of-toronto-scarborough/" element={<UofTScarborough />} />
        <Route path="/study-room/york-university/" element={<YorkUniversity />} />
        <Route path="/study-room/toronto-metropolitan-university/" element={<TorontoMetropolitanUniversity />} />
        <Route path="/study-room/ocad-university/" element={<OCADUniversity />} />
        <Route path="/study-room/university-of-guelph-humber/" element={<GuelphHumber />} />
        <Route path="/study-room/seneca-college/" element={<SenecaCollege />} />
        <Route path="/study-room/humber-college/" element={<HumberCollege />} />
        {/* Canadian Universities */}
        <Route path="/study-room/mcgill-university/" element={<McGillUniversity />} />
        <Route path="/study-room/ubc-vancouver/" element={<UBCVancouver />} />
        <Route path="/study-room/university-of-alberta/" element={<UniversityOfAlberta />} />
        <Route path="/study-room/university-of-calgary/" element={<UniversityOfCalgary />} />
        <Route path="/study-room/university-of-ottawa/" element={<UniversityOfOttawa />} />
        <Route path="/study-room/mcmaster-university/" element={<McMasterUniversity />} />
        <Route path="/study-room/university-of-waterloo/" element={<UniversityOfWaterloo />} />
        <Route path="/study-room/western-university/" element={<WesternUniversity />} />
        <Route path="/study-room/queens-university/" element={<QueensUniversity />} />
        <Route path="/study-room/university-of-manitoba/" element={<UniversityOfManitoba />} />
        <Route path="/study-room/university-of-saskatchewan/" element={<UniversityOfSaskatchewan />} />
        <Route path="/study-room/universite-laval/" element={<UniversiteLaval />} />
        <Route path="/study-room/universite-de-montreal/" element={<UniversiteDeMontreal />} />
        <Route path="/study-room/dalhousie-university/" element={<DalhousieUniversity />} />
        <Route path="/study-room/simon-fraser-university/" element={<SimonFraserUniversity />} />
        <Route path="/study-room/concordia-university/" element={<ConcordiaUniversity />} />
        <Route path="/study-room/university-of-victoria/" element={<UniversityOfVictoria />} />
        <Route path="/study-room/memorial-university/" element={<MemorialUniversity />} />
        <Route path="/study-room/carleton-university/" element={<CarletonUniversity />} />
        <Route path="/study-room/university-of-new-brunswick/" element={<UniversityOfNewBrunswick />} />
        {/* US Universities */}
        <Route path="/study-room/university-of-central-florida/" element={<UniversityOfCentralFlorida />} />
        <Route path="/study-room/texas-am-university/" element={<TexasAMUniversity />} />
        <Route path="/study-room/ohio-state-university/" element={<OhioStateUniversity />} />
        <Route path="/study-room/florida-international-university/" element={<FloridaInternationalUniversity />} />
        <Route path="/study-room/university-of-florida/" element={<UniversityOfFlorida />} />
        <Route path="/study-room/new-york-university/" element={<NewYorkUniversity />} />
        <Route path="/study-room/university-of-texas-austin/" element={<UniversityOfTexasAustin />} />
        <Route path="/study-room/arizona-state-university/" element={<ArizonaStateUniversity />} />
        <Route path="/study-room/university-of-minnesota/" element={<UniversityOfMinnesota />} />
        <Route path="/study-room/michigan-state-university/" element={<MichiganStateUniversity />} />
        <Route path="/study-room/rutgers-university/" element={<RutgersUniversity />} />
        <Route path="/study-room/university-of-illinois/" element={<UniversityOfIllinois />} />
        <Route path="/study-room/university-of-washington/" element={<UniversityOfWashington />} />
        <Route path="/study-room/penn-state-university/" element={<PennStateUniversity />} />
        <Route path="/study-room/purdue-university/" element={<PurdueUniversity />} />
        <Route path="/study-room/university-of-southern-california/" element={<UniversityOfSouthernCalifornia />} />
        <Route path="/study-room/indiana-university/" element={<IndianaUniversity />} />
        <Route path="/study-room/ucla/" element={<UCLA />} />
        <Route path="/study-room/university-of-michigan/" element={<UniversityOfMichigan />} />
        <Route path="/study-room/uc-berkeley/" element={<UCBerkeley />} />
        <Route path="/studyverse/" element={<StudyVerse />} />
        <Route path="/studyverse/history/" element={<StudyVerseHistory />} />
        <Route path="/study-verse/" element={<StudyVerseRedirect />} />
        <Route path="/study-verse" element={<StudyVerseRedirect />} />
        <Route path="/groove/" element={<Groove />} />
        <Route path="/groove/history/" element={<GrooveHistory />} />
        <Route path="/edmodo/" element={<Edmodo />} />
        <Route path="/edmodo/history/" element={<EdmodoHistory />} />
        <Route path="/study-with-skz/" element={<StudyWithSKZ />} />
        <Route path="/study-with-itzy/" element={<StudyWithItzy />} />
        <Route path="/study-with-blackpink/" element={<StudyWithBlackpink />} />
        <Route path="/study-with-aespa/" element={<StudyWithAespa />} />
        <Route path="/study-with-twice/" element={<StudyWithTwice />} />
        <Route path="/study-with-ateez/" element={<StudyWithAteez />} />
        <Route path="/study-with-bts/" element={<StudyWithBTS />} />
        <Route path="/study-with-enhypen/" element={<StudyWithEnhypen />} />
        <Route path="/study-with-nct/" element={<StudyWithNCT />} />
        <Route path="/study-with-txt/" element={<StudyWithTXT />} />
        <Route path="/study-with-seventeen/" element={<StudyWithSeventeen />} />
        <Route path="/study-with-exo/" element={<StudyWithEXO />} />
        <Route path="/study-with-monsta-x/" element={<StudyWithMonstaX />} />
        <Route path="/study-with-the-boyz/" element={<StudyWithTheBoyz />} />
        <Route path="/study-with-treasure/" element={<StudyWithTreasure />} />
        <Route path="/study-with-got7/" element={<StudyWithGOT7 />} />
        <Route path="/study-with-sf9/" element={<StudyWithSF9 />} />
        <Route path="/study-with-loona/" element={<StudyWithLoona />} />
        <Route path="/study-with-red-velvet/" element={<StudyWithRedVelvet />} />
        <Route path="/study-with-mamamoo/" element={<StudyWithMamamoo />} />
        <Route path="/study-with-kpop/" element={<StudyWithKpop />} />
        <Route path="/study-with-me/" element={<StudyWithMe />} />
        <Route path="/study-with-friends/" element={<StudyWithFriends />} />
        <Route path="/study-with-strangers/" element={<StudyWithStrangers />} />
        <Route path="/group-study/" element={<GroupStudy />} />
        <Route path="/zoom-study-room/" element={<ZoomStudyRoom />} />
        <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use/" element={<TermsOfUse />} />
        <Route path="/registration-policy/" element={<UserRegistrationPolicy />} />
        <Route path="/content-monitoring-policy/" element={<ContentMonitoringPolicy />} />
        <Route path="/report-policy/" element={<ReportPolicy />} />
        <Route path="/blog/" element={<Blog />} />
        <Route path="/blog/how-turning-on-my-camera-boosted-my-productivity/" element={<HowTurningOnMyCameraBoostedMyProductivity />} />
        <Route path="/blog/how-to-stop-procrastination/" element={<HowToStopProcrastination />} />
        <Route path="/blog/top-10-digital-tools-for-academic-success/" element={<Top10DigitalToolsForAcademicSuccess />} />
        <Route path="/blog/preparing-for-major-test/" element={<PreparingForMajorTest />} />
        <Route path="/blog/benefits-of-online-learning-community/" element={<BenefitsOfOnlineLearningCommunity />} />
        <Route path="/blog/science-behind-study-with-me/" element={<ScienceBehindStudyWithMe />} />
        <Route path="/blog/apps-boost-productivity-college/" element={<AppsBoostProductivityCollege />} />
        <Route path="/blog/apps-boost-organization-college/" element={<AppsBoostOrganizationCollege />} />
        <Route path="/blog/apps-boost-self-growth-college/" element={<AppsBoostSelfGrowthCollege />} />
        <Route path="/blog/paper-vs-digital-planning/" element={<PaperVsDigitalPlanning />} />
        <Route path="/blog/task-management-tools-review/" element={<TaskManagementToolsReview />} />
        {/* Online Study routes */}
        <Route path="/online-study/" element={<OnlineStudy />} />
        <Route path="/online-study/khan-academy/" element={<KhanAcademy />} />
        <Route path="/online-study/quizlet/" element={<Quizlet />} />
        <Route path="/online-study/wolfram-alpha/" element={<WolframAlpha />} />
        <Route path="/online-study/sparknotes/" element={<SparkNotes />} />
        <Route path="/online-study/magoosh/" element={<Magoosh />} />
        <Route path="/online-study/kaplan/" element={<Kaplan />} />
        <Route path="/online-study/princeton-review/" element={<PrincetonReview />} />
        <Route path="/online-study/fiveable/" element={<Fiveable />} />
        <Route path="/online-study/chegg/" element={<Chegg />} />
        <Route path="/online-study/course-hero/" element={<CourseHero />} />
        <Route path="/online-study/brainly/" element={<Brainly />} />
        <Route path="/online-study/focusmate/" element={<Focusmate />} />
        <Route path="/online-study/studystream-platform/" element={<StudyStreamPlatform />} />
        <Route path="/online-study/study-together/" element={<StudyTogether />} />
        <Route path="/online-study/coursera/" element={<Coursera />} />
        <Route path="/online-study/edx/" element={<Edx />} />
        <Route path="/online-study/udemy/" element={<Udemy />} />
        <Route path="/online-study/ypt-yeolpumta/" element={<YPTYeolPumTa />} />
        <Route path="/online-workspace/flown/" element={<Flown />} />
        <Route path="/online-workspace/gather-town/" element={<GatherTown />} />
        <Route path="/online-workspace/caveday/" element={<Caveday />} />
        <Route path="/online-workspace/cofocus/" element={<Cofocus />} />
        <Route path="/blocked-preview/" element={<BlockedPreview />} />
        <Route path="/openstudy/" element={<OpenStudy />} />
        <Route path="/openstudy/history/" element={<OpenStudyHistory />} />
        <Route path="/wunderlist/" element={<Wunderlist />} />
        <Route path="/wunderlist/history/" element={<WunderlistHistory />} />
        <Route path="/altspacevr/" element={<AltspaceVR />} />
        <Route path="/altspacevr/history/" element={<AltspaceVRHistory />} />
        <Route path="/google-wave/" element={<GoogleWave />} />
        <Route path="/google-wave/history/" element={<GoogleWaveHistory />} />
        <Route path="/hipchat/" element={<HipChat />} />
        <Route path="/hipchat/history/" element={<HipChatHistory />} />
        <Route path="/stride/" element={<Stride />} />
        <Route path="/stride/history/" element={<StrideHistory />} />
        <Route path="/sunrise-calendar/" element={<SunriseCalendar />} />
        <Route path="/sunrise-calendar/history/" element={<SunriseCalendarHistory />} />
        <Route path="/mailbox/" element={<Mailbox />} />
        <Route path="/mailbox/history/" element={<MailboxHistory />} />
        <Route path="/yahoo-groups/" element={<YahooGroups />} />
        <Route path="/yahoo-groups/history/" element={<YahooGroupsHistory />} />
        <Route path="/google-spaces/" element={<GoogleSpaces />} />
        <Route path="/google-spaces/history/" element={<GoogleSpacesHistory />} />
        <Route path="/quill/" element={<Quill />} />
        <Route path="/quill/history/" element={<QuillHistory />} />
        <Route path="/google-hangouts/" element={<GoogleHangouts />} />
        <Route path="/google-hangouts/history/" element={<GoogleHangoutsHistory />} />
        <Route path="/chalkup/" element={<Chalkup />} />
        <Route path="/chalkup/history/" element={<ChalkupHistory />} />
        <Route path="/todaysmeet/" element={<TodaysMeet />} />
        <Route path="/todaysmeet/history/" element={<TodaysMeetHistory />} />
        <Route path="/wikispaces/" element={<Wikispaces />} />
        <Route path="/wikispaces/history/" element={<WikispacesHistory />} />
        <Route path="/astrid/" element={<Astrid />} />
        <Route path="/astrid/history/" element={<AstridHistory />} />
        <Route path="/producteev/" element={<Producteev />} />
        <Route path="/producteev/history/" element={<ProducteevHistory />} />
        <Route path="/sandglaz/" element={<Sandglaz />} />
        <Route path="/sandglaz/history/" element={<SandglazHistory />} />
        <Route path="/fetchnotes/" element={<Fetchnotes />} />
        <Route path="/fetchnotes/history/" element={<FetchnotesHistory />} />
        <Route path="/iqtell/" element={<IQTell />} />
        <Route path="/iqtell/history/" element={<IQTellHistory />} />
        <Route path="/height/" element={<Height />} />
        <Route path="/height/history/" element={<HeightHistory />} />
        <Route path="/google-tables/" element={<GoogleTables />} />
        <Route path="/google-tables/history/" element={<GoogleTablesHistory />} />
        <Route path="/alternatives/" element={<Alternatives />} />
        <Route path="*" element={<NotFound />} />
        </Routes>
      </CountryBlock>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
